import { ChangeDetectionStrategy, Component, computed, input, output, signal } from '@angular/core';

const MAXIMUM_THREAD_LEVEL = 1;

@Component({
  selector: 'lib-social-wall-reply',
  templateUrl: './social-wall-reply.component.html',
  styleUrl: './social-wall-reply.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class SocialWallReplyComponent {

  public reply = input<any>({});
  public level = input(1);

  public like = output<any>();
  public replyTo = output<any>();

  public expanded = signal(false);

  public childReplies = computed<any[]>(() => this.reply()?.replies ?? []);
  public allowReply = computed(() => this.level() <= MAXIMUM_THREAD_LEVEL);
  public canExpand = computed(() => this.allowReply() && !!this.childReplies().length);

  public toggleReplies(): void {
    this.expanded.update(expanded => !expanded);
  }

}
